import { lazy } from 'react'

export const PaymentVariant6 = lazy(() => import('./PaymentVariant6'))
